import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left",
  "use": "left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"left\"><path d=\"M227.211 460.526a70.815 70.815 0 0 0 0 103.358l460.505 438.605a78.797 78.797 0 0 0 54.34 21.388 75.011 75.011 0 0 0 76.75-73.067 71.634 71.634 0 0 0-22.513-51.167l-406.268-387.95L796.293 124.87a71.634 71.634 0 0 0 22.513-51.78A75.011 75.011 0 0 0 742.056.02a78.797 78.797 0 0 0-54.34 21.388z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol